import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { FlowData } from '@pin-up-global/flow-editor';
import { ApiService } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import {
  BlocksDefinitionsReq,
  BlocksDefinitionsRes,
  Flow,
  FlowContent,
  FlowContentReq,
  FlowReq,
} from './flow.abstraction';

@Injectable()
export class FlowApiServiceMock extends ApiService {
  isLoading$ = this._isLoading$;

  getFlow(params: FlowReq): Observable<Flow> {
    return of({
      id: 1,
      name: 'Flow 1',
      botId: 1,
      triggers: [],
      contents: [
        {
          id: 1,
          flowId: 1,
          version: '1.0.0',
          isMain: true,
          deletedAt: '2021-07-01T00:00:00.000Z',
          createdAt: '2021-07-01T00:00:00.000Z',
          updatedAt: '2021-07-01T00:00:00.000Z',
        },
      ],
      createdAt: '2021-07-01T00:00:00.000Z',
      updatedAt: '2021-07-01T00:00:00.000Z',
      deletedAt: '2021-07-01T00:00:00.000Z',
      isActive: true,
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  updateFlow(params: FlowReq, body: Partial<Pick<Flow, 'name' | 'isActive' | 'triggers'>>): Observable<Flow> {
    return of({
      id: 1,
      name: 'Flow 1',
      botId: 1,
      triggers: [],
      contents: [
        {
          id: 1,
          flowId: 1,
          version: '1.0.0',
          isMain: true,
          deletedAt: '2021-07-01T00:00:00.000Z',
          createdAt: '2021-07-01T00:00:00.000Z',
          updatedAt: '2021-07-01T00:00:00.000Z',
        },
      ],
      createdAt: '2021-07-01T00:00:00.000Z',
      updatedAt: '2021-07-01T00:00:00.000Z',
      deletedAt: '2021-07-01T00:00:00.000Z',
      isActive: true,
      ...body,
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  getFlowContent(params: FlowContentReq): Observable<FlowContent> {
    const flowData = {
      "blocks": [{ "id": "start", "nodeFieldType": "START", "coords": { "x": 10, "y": 10 } }, {
        "icon": "iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFMSURBVHgB7ZY/TgJREId/S0ysTLC1Ag+glTZaeAQrK40xXgBOIJ4ALLQz0egBvICJjZWFCZU27Fa0LFBBwfKGFxJCNfMmgRcyX7P7kjfZb+f9mUnwVFxjghYSlBEXmXNqJHgsUjeoIE7yEuKVI8olRI4JajFBLSaoZUsy+e4IqB24y2kbQeQj4OUPqH/zY9iCzVMvp4F+rHYI9MdA44cXQ6Wu4Ezs3foPVN9ckRwiiMoOkF75TO4+82LYe3C+rKFyi7GSLWKnWMtmC6aXftNzxyFs1kW9TPVdNg7BDokWE1yESh1BpY5L8CE523PdzbF/Snn9588VC1IWmifA+T7EUOYe2vxOhhAL/l74Yj//WKstWzIpYkGS++j4plPT2XBhC2YDUPeIm0/gq4uVwW5Y14Xdg1pMUIsJajFBLSSYI14yEqzTC2KjmCXufgpw+VCp9xpinwAAAABJRU5ErkJggg==",
        "coords": { "x": 305.5, "y": 306.5 },
        "defId": "contentMessage1",
        "caption": "Message",
        "isConnectableTo": true,
        "id": "b28b21a8-f1ba-4104-8cae-03333ec4b6e2",
        // @ts-ignore
        "parentIdsPath": [],
        "nodeFieldType": "CONTENT_MESSAGE",
        "name": "messageForm1",
        "isConnectableFrom": false,
        "items": [{
          "id": "62cabfd7-ef0f-46dc-b60f-6795908bfe9a",
          "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2"],
          "nodeFieldType": "IMAGE",
          "name": "image1",
          "isConnectableFrom": false,
          "value": ""
        }, {
          "id": "4119f8d1-b993-426c-b28c-600de8117f58",
          "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2"],
          "nodeFieldType": "RICH_TEXT",
          "name": "richText1",
          "isConnectableFrom": false,
          "value": ""
        }, {
          "id": "9178838a-5b5d-4021-b6b4-1706c826d0bc",
          "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2"],
          "nodeFieldType": "CONTAINER",
          "name": "cloneablePanelContainer2",
          "isConnectableFrom": false,
          "items": [{
            "id": "cf6f4456-5c4e-4605-a0ec-d87d638a6981",
            "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2", "9178838a-5b5d-4021-b6b4-1706c826d0bc"],
            "items": [{
              "id": "f790238b-bf90-4217-9556-9630917b8321",
              "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2", "9178838a-5b5d-4021-b6b4-1706c826d0bc", "cf6f4456-5c4e-4605-a0ec-d87d638a6981"],
              "nodeFieldType": "USER_CHOICE",
              "name": "layoutContainer2",
              "isConnectableFrom": true,
              "items": [{
                "id": "76a78f4e-a32e-4ef2-8914-227a4eba9e4b",
                "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2", "9178838a-5b5d-4021-b6b4-1706c826d0bc", "cf6f4456-5c4e-4605-a0ec-d87d638a6981", "f790238b-bf90-4217-9556-9630917b8321"],
                "nodeFieldType": "TEXT",
                "name": "text2",
                "isConnectableFrom": false,
                "value": "Text on button"
              }]
            }]
          }, {
            "id": "6e78ba8d-ab1f-4b17-b1ed-a80c901930ae",
            "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2", "9178838a-5b5d-4021-b6b4-1706c826d0bc"],
            "items": [{
              "id": "b83ff6df-9c52-472c-b4e6-2f0c08e3de9d",
              "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2", "9178838a-5b5d-4021-b6b4-1706c826d0bc", "6e78ba8d-ab1f-4b17-b1ed-a80c901930ae"],
              "nodeFieldType": "USER_CHOICE",
              "name": "layoutContainer2",
              "isConnectableFrom": true,
              "items": [{
                "id": "b6d45c76-94b0-4c6d-bc72-049cd7f273be",
                "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2", "9178838a-5b5d-4021-b6b4-1706c826d0bc", "6e78ba8d-ab1f-4b17-b1ed-a80c901930ae", "b83ff6df-9c52-472c-b4e6-2f0c08e3de9d"],
                "nodeFieldType": "TEXT",
                "name": "text2",
                "isConnectableFrom": false,
                "value": "Text on button"
              }]
            }]
          }]
        }, {
          "id": "1ba0d63e-8eb8-45bc-8c81-edc44b5fb0c7",
          "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2"],
          "nodeFieldType": "CONTAINER",
          "name": "cloneablePanelContainer3",
          "isConnectableFrom": false,
          "items": []
        }, {
          "id": "b6a110e0-d0c1-4d8b-8050-43fc322ed55c",
          "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2"],
          "nodeFieldType": "CONTAINER",
          "name": "cloneablePanelContainerTimeout",
          "isConnectableFrom": false,
          "items": []
        }]
      }, {
        "icon": "iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFMSURBVHgB7ZY/TgJREId/S0ysTLC1Ag+glTZaeAQrK40xXgBOIJ4ALLQz0egBvICJjZWFCZU27Fa0LFBBwfKGFxJCNfMmgRcyX7P7kjfZb+f9mUnwVFxjghYSlBEXmXNqJHgsUjeoIE7yEuKVI8olRI4JajFBLSaoZUsy+e4IqB24y2kbQeQj4OUPqH/zY9iCzVMvp4F+rHYI9MdA44cXQ6Wu4Ezs3foPVN9ckRwiiMoOkF75TO4+82LYe3C+rKFyi7GSLWKnWMtmC6aXftNzxyFs1kW9TPVdNg7BDokWE1yESh1BpY5L8CE523PdzbF/Snn9588VC1IWmifA+T7EUOYe2vxOhhAL/l74Yj//WKstWzIpYkGS++j4plPT2XBhC2YDUPeIm0/gq4uVwW5Y14Xdg1pMUIsJajFBLSSYI14yEqzTC2KjmCXufgpw+VCp9xpinwAAAABJRU5ErkJggg==",
        "coords": { "x": 985.5, "y": 416.5 },
        "defId": "contentMessage2",
        "caption": "Sticker",
        "isConnectableTo": true,
        "id": "44aab6b3-c406-4016-a0e5-ee3a3a7d0138",
        "parentIdsPath": [],
        "nodeFieldType": "CONTENT_MESSAGE",
        "name": "stickerForm1",
        "isConnectableFrom": true,
        "items": [{
          "id": "fefe2d30-396b-4ead-84f9-e02ab3a595ab",
          "parentIdsPath": ["44aab6b3-c406-4016-a0e5-ee3a3a7d0138"],
          "nodeFieldType": "STICKER",
          "name": "dropdown1",
          "isConnectableFrom": false,
          "value": "abc123"
        }]
      }, {
        "icon": "iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFMSURBVHgB7ZY/TgJREId/S0ysTLC1Ag+glTZaeAQrK40xXgBOIJ4ALLQz0egBvICJjZWFCZU27Fa0LFBBwfKGFxJCNfMmgRcyX7P7kjfZb+f9mUnwVFxjghYSlBEXmXNqJHgsUjeoIE7yEuKVI8olRI4JajFBLSaoZUsy+e4IqB24y2kbQeQj4OUPqH/zY9iCzVMvp4F+rHYI9MdA44cXQ6Wu4Ezs3foPVN9ckRwiiMoOkF75TO4+82LYe3C+rKFyi7GSLWKnWMtmC6aXftNzxyFs1kW9TPVdNg7BDokWE1yESh1BpY5L8CE523PdzbF/Snn9588VC1IWmifA+T7EUOYe2vxOhhAL/l74Yj//WKstWzIpYkGS++j4plPT2XBhC2YDUPeIm0/gq4uVwW5Y14Xdg1pMUIsJajFBLSSYI14yEqzTC2KjmCXufgpw+VCp9xpinwAAAABJRU5ErkJggg==",
        "coords": { "x": 721.5, "y": 88.5 },
        "defId": "contentMessage2",
        "caption": "Sticker",
        "isConnectableTo": true,
        "id": "a762b410-77eb-40ca-ad65-20bdd4431874",
        "parentIdsPath": [],
        "nodeFieldType": "CONTENT_MESSAGE",
        "name": "stickerForm1",
        "isConnectableFrom": true,
        "items": [{
          "id": "ab544402-703f-4068-894b-2341069dc3ee",
          "parentIdsPath": ["a762b410-77eb-40ca-ad65-20bdd4431874"],
          "nodeFieldType": "STICKER",
          "name": "dropdown1",
          "isConnectableFrom": false,
          "value": "abc123"
        }]
      }, {
        "icon": "iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFMSURBVHgB7ZY/TgJREId/S0ysTLC1Ag+glTZaeAQrK40xXgBOIJ4ALLQz0egBvICJjZWFCZU27Fa0LFBBwfKGFxJCNfMmgRcyX7P7kjfZb+f9mUnwVFxjghYSlBEXmXNqJHgsUjeoIE7yEuKVI8olRI4JajFBLSaoZUsy+e4IqB24y2kbQeQj4OUPqH/zY9iCzVMvp4F+rHYI9MdA44cXQ6Wu4Ezs3foPVN9ckRwiiMoOkF75TO4+82LYe3C+rKFyi7GSLWKnWMtmC6aXftNzxyFs1kW9TPVdNg7BDokWE1yESh1BpY5L8CE523PdzbF/Snn9588VC1IWmifA+T7EUOYe2vxOhhAL/l74Yj//WKstWzIpYkGS++j4plPT2XBhC2YDUPeIm0/gq4uVwW5Y14Xdg1pMUIsJajFBLSSYI14yEqzTC2KjmCXufgpw+VCp9xpinwAAAABJRU5ErkJggg==",
        "coords": { "x": 623.5, "y": 966.5 },
        "defId": "contentMessage1",
        "caption": "Message",
        "isConnectableTo": true,
        "id": "60ba1e3c-0c8d-4437-b852-cf67c0a44a2a",
        "parentIdsPath": [],
        "nodeFieldType": "CONTENT_MESSAGE",
        "name": "messageForm1",
        "isConnectableFrom": false,
        "items": [{
          "id": "d9e14ffe-5762-4755-af24-918e557a2d02",
          "parentIdsPath": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a"],
          "nodeFieldType": "IMAGE",
          "name": "image1",
          "isConnectableFrom": false,
          "value": ""
        }, {
          "id": "2750bf16-5d94-47f0-9c38-7ac3528e868a",
          "parentIdsPath": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a"],
          "nodeFieldType": "RICH_TEXT",
          "name": "richText1",
          "isConnectableFrom": false,
          "value": ""
        }, {
          "id": "003b781c-9660-437c-9995-8170de91d37e",
          "parentIdsPath": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a"],
          "nodeFieldType": "CONTAINER",
          "name": "cloneablePanelContainer2",
          "isConnectableFrom": false,
          "items": [{
            "id": "65f0396e-690a-404b-97eb-1aaad718c1f3",
            "parentIdsPath": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a", "003b781c-9660-437c-9995-8170de91d37e"],
            "items": [{
              "id": "5811e1a3-6747-43b9-b5f4-ef6530651453",
              "parentIdsPath": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a", "003b781c-9660-437c-9995-8170de91d37e", "65f0396e-690a-404b-97eb-1aaad718c1f3"],
              "nodeFieldType": "USER_CHOICE",
              "name": "layoutContainer2",
              "isConnectableFrom": true,
              "items": [{
                "id": "4a321925-5c46-46fb-b1fa-9dedcf163792",
                "parentIdsPath": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a", "003b781c-9660-437c-9995-8170de91d37e", "65f0396e-690a-404b-97eb-1aaad718c1f3", "5811e1a3-6747-43b9-b5f4-ef6530651453"],
                "nodeFieldType": "TEXT",
                "name": "text2",
                "isConnectableFrom": false,
                "value": "Text on button"
              }]
            }]
          }]
        }, {
          "id": "57079cbd-d5a3-47c8-9eb1-32c691146870",
          "parentIdsPath": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a"],
          "nodeFieldType": "CONTAINER",
          "name": "cloneablePanelContainer3",
          "isConnectableFrom": false,
          "items": []
        }, {
          "id": "80297654-8ed4-4745-baa9-c5ea24ecaac3",
          "parentIdsPath": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a"],
          "nodeFieldType": "CONTAINER",
          "name": "cloneablePanelContainerTimeout",
          "isConnectableFrom": false,
          "items": []
        }]
      }, {
        "icon": "iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAF+SURBVHgB7Ze/S8NAFMe/FwqGDpJBxEXp6J+hYx2d7GL9AQ5uCuKktqNURBAcHBwcimM3N5266iQ4OBQXBx2CQ4mLp+8kJUKHl5x3nOU+EN4REvLh3d27F7G6f1SXEieAjOAUoicEGqVvuYZ7coSsUOICGsBdogCO4wV18YK6eEFdSnkenojGsb5YxczUJMrh2OD+W/yOneNzmIAtSHLNzfovMRuwBWsL80que/+A9vUN+skHbMBeg7OVaRU7t11rcgQ7g+UwVJHWG5fW9oaKhxdXud7LYnwX09rdXVtSsQhGBdPM6UgaFSQ5XUnjU6wrmatQD4M2Qp4PppLcwj5aR90wOJnITm065VyslpnseuRiVFBXjjAqqCtHWC0zRWBvkn6SqPOYLhpz+IsekZ3B55dXFWvVucLnahHEyl5Lch78aViXB11NFpMdNTuDJHFwdom7xyc3+0GCJE/bHdjE/3bq4gV18YK6/ANBgRiuIkQvgJRbNIBrCBFDfja/APtHoWK8YrmAAAAAAElFTkSuQmCC",
        "coords": { "x": 1061.5, "y": 842.5 },
        "defId": "externalFlow1",
        "caption": "External Flow",
        "isConnectableTo": true,
        "id": "2efa7ada-66a7-4c5b-8580-8442f62f8152",
        "parentIdsPath": [],
        "nodeFieldType": "EXTERNAL_FLOW",
        "name": "externalFlowForm1",
        "isConnectableFrom": false,
        "items": [{
          "id": "77054769-1660-488a-af4e-e5e8eb9702b7",
          "parentIdsPath": ["2efa7ada-66a7-4c5b-8580-8442f62f8152"],
          "nodeFieldType": "TEXT",
          "name": "dropdown2",
          "isConnectableFrom": false,
          "value": "3"
        }]
      }, {
        "icon": "iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAF+SURBVHgB7Ze/S8NAFMe/FwqGDpJBxEXp6J+hYx2d7GL9AQ5uCuKktqNURBAcHBwcimM3N5266iQ4OBQXBx2CQ4mLp+8kJUKHl5x3nOU+EN4REvLh3d27F7G6f1SXEieAjOAUoicEGqVvuYZ7coSsUOICGsBdogCO4wV18YK6eEFdSnkenojGsb5YxczUJMrh2OD+W/yOneNzmIAtSHLNzfovMRuwBWsL80que/+A9vUN+skHbMBeg7OVaRU7t11rcgQ7g+UwVJHWG5fW9oaKhxdXud7LYnwX09rdXVtSsQhGBdPM6UgaFSQ5XUnjU6wrmatQD4M2Qp4PppLcwj5aR90wOJnITm065VyslpnseuRiVFBXjjAqqCtHWC0zRWBvkn6SqPOYLhpz+IsekZ3B55dXFWvVucLnahHEyl5Lch78aViXB11NFpMdNTuDJHFwdom7xyc3+0GCJE/bHdjE/3bq4gV18YK6/ANBgRiuIkQvgJRbNIBrCBFDfja/APtHoWK8YrmAAAAAAElFTkSuQmCC",
        "coords": { "x": 373.5, "y": 568.5 },
        "defId": "externalFlow1",
        "caption": "External Flow",
        "isConnectableTo": true,
        "id": "36d9beca-30e9-46b9-b609-17e0f70c0ff3",
        "parentIdsPath": [],
        "nodeFieldType": "EXTERNAL_FLOW",
        "name": "externalFlowForm1",
        "isConnectableFrom": false,
        "items": [{
          "id": "7f84c3bc-46dc-426c-a3e6-e3313859bf1f",
          "parentIdsPath": ["36d9beca-30e9-46b9-b609-17e0f70c0ff3"],
          "nodeFieldType": "TEXT",
          "name": "dropdown2",
          "isConnectableFrom": false,
          "value": "3"
        }]
      }],
      "connections": [{
        "id": "reactflow__edge-startstart-b28b21a8-f1ba-4104-8cae-03333ec4b6e2b28b21a8-f1ba-4104-8cae-03333ec4b6e2",
        "target": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2"],
        "source": ["start"]
      }, {
        "id": "reactflow__edge-b28b21a8-f1ba-4104-8cae-03333ec4b6e2f790238b-bf90-4217-9556-9630917b8321-a762b410-77eb-40ca-ad65-20bdd4431874a762b410-77eb-40ca-ad65-20bdd4431874",
        "target": ["a762b410-77eb-40ca-ad65-20bdd4431874"],
        "source": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2", "9178838a-5b5d-4021-b6b4-1706c826d0bc", "cf6f4456-5c4e-4605-a0ec-d87d638a6981", "f790238b-bf90-4217-9556-9630917b8321"]
      }, {
        "id": "reactflow__edge-a762b410-77eb-40ca-ad65-20bdd4431874a762b410-77eb-40ca-ad65-20bdd4431874-44aab6b3-c406-4016-a0e5-ee3a3a7d013844aab6b3-c406-4016-a0e5-ee3a3a7d0138",
        "target": ["44aab6b3-c406-4016-a0e5-ee3a3a7d0138"],
        "source": ["a762b410-77eb-40ca-ad65-20bdd4431874"]
      }, {
        "id": "reactflow__edge-44aab6b3-c406-4016-a0e5-ee3a3a7d013844aab6b3-c406-4016-a0e5-ee3a3a7d0138-60ba1e3c-0c8d-4437-b852-cf67c0a44a2a60ba1e3c-0c8d-4437-b852-cf67c0a44a2a",
        "target": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a"],
        "source": ["44aab6b3-c406-4016-a0e5-ee3a3a7d0138"]
      }, {
        "id": "reactflow__edge-60ba1e3c-0c8d-4437-b852-cf67c0a44a2a5811e1a3-6747-43b9-b5f4-ef6530651453-2efa7ada-66a7-4c5b-8580-8442f62f81522efa7ada-66a7-4c5b-8580-8442f62f8152",
        "target": ["2efa7ada-66a7-4c5b-8580-8442f62f8152"],
        "source": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a", "003b781c-9660-437c-9995-8170de91d37e", "65f0396e-690a-404b-97eb-1aaad718c1f3", "5811e1a3-6747-43b9-b5f4-ef6530651453"]
      }, {
        "id": "reactflow__edge-b28b21a8-f1ba-4104-8cae-03333ec4b6e2b83ff6df-9c52-472c-b4e6-2f0c08e3de9d-36d9beca-30e9-46b9-b609-17e0f70c0ff336d9beca-30e9-46b9-b609-17e0f70c0ff3",
        "target": ["36d9beca-30e9-46b9-b609-17e0f70c0ff3"],
        "source": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2", "9178838a-5b5d-4021-b6b4-1706c826d0bc", "6e78ba8d-ab1f-4b17-b1ed-a80c901930ae", "b83ff6df-9c52-472c-b4e6-2f0c08e3de9d"]
      }]
    };

    return of({
        id: 1,
        flowId: 1,
        version: '1.0.0',
        isMain: true,
        deletedAt: '2021-07-01T00:00:00.000Z',
        data: flowData as FlowData,
      },
    ).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  updateFlowContent(params: FlowContentReq, body: Pick<FlowContent, 'data'>): Observable<FlowContent> {
    return of({
      id: 1,
      flowId: 1,
      version: '1.0.0',
      deletedAt: '2021-07-01T00:00:00.000Z',
      isMain: true,
      ...body,
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  getBlocksDefinitions(params: BlocksDefinitionsReq): Observable<BlocksDefinitionsRes> {
    const flowData = {
      "blocks": [{ "id": "start", "nodeFieldType": "START", "coords": { "x": 10, "y": 10 } }, {
        "icon": "iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFMSURBVHgB7ZY/TgJREId/S0ysTLC1Ag+glTZaeAQrK40xXgBOIJ4ALLQz0egBvICJjZWFCZU27Fa0LFBBwfKGFxJCNfMmgRcyX7P7kjfZb+f9mUnwVFxjghYSlBEXmXNqJHgsUjeoIE7yEuKVI8olRI4JajFBLSaoZUsy+e4IqB24y2kbQeQj4OUPqH/zY9iCzVMvp4F+rHYI9MdA44cXQ6Wu4Ezs3foPVN9ckRwiiMoOkF75TO4+82LYe3C+rKFyi7GSLWKnWMtmC6aXftNzxyFs1kW9TPVdNg7BDokWE1yESh1BpY5L8CE523PdzbF/Snn9588VC1IWmifA+T7EUOYe2vxOhhAL/l74Yj//WKstWzIpYkGS++j4plPT2XBhC2YDUPeIm0/gq4uVwW5Y14Xdg1pMUIsJajFBLSSYI14yEqzTC2KjmCXufgpw+VCp9xpinwAAAABJRU5ErkJggg==",
        "coords": { "x": 305.5, "y": 306.5 },
        "defId": "contentMessage1",
        "caption": "Message",
        "isConnectableTo": true,
        "id": "b28b21a8-f1ba-4104-8cae-03333ec4b6e2",
        // @ts-ignore
        "parentIdsPath": [],
        "nodeFieldType": "CONTENT_MESSAGE",
        "name": "messageForm1",
        "isConnectableFrom": false,
        "items": [{
          "id": "62cabfd7-ef0f-46dc-b60f-6795908bfe9a",
          "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2"],
          "nodeFieldType": "IMAGE",
          "name": "image1",
          "isConnectableFrom": false,
          "value": ""
        }, {
          "id": "4119f8d1-b993-426c-b28c-600de8117f58",
          "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2"],
          "nodeFieldType": "RICH_TEXT",
          "name": "richText1",
          "isConnectableFrom": false,
          "value": ""
        }, {
          "id": "9178838a-5b5d-4021-b6b4-1706c826d0bc",
          "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2"],
          "nodeFieldType": "CONTAINER",
          "name": "cloneablePanelContainer2",
          "isConnectableFrom": false,
          "items": [{
            "id": "cf6f4456-5c4e-4605-a0ec-d87d638a6981",
            "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2", "9178838a-5b5d-4021-b6b4-1706c826d0bc"],
            "items": [{
              "id": "f790238b-bf90-4217-9556-9630917b8321",
              "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2", "9178838a-5b5d-4021-b6b4-1706c826d0bc", "cf6f4456-5c4e-4605-a0ec-d87d638a6981"],
              "nodeFieldType": "USER_CHOICE",
              "name": "layoutContainer2",
              "isConnectableFrom": true,
              "items": [{
                "id": "76a78f4e-a32e-4ef2-8914-227a4eba9e4b",
                "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2", "9178838a-5b5d-4021-b6b4-1706c826d0bc", "cf6f4456-5c4e-4605-a0ec-d87d638a6981", "f790238b-bf90-4217-9556-9630917b8321"],
                "nodeFieldType": "TEXT",
                "name": "text2",
                "isConnectableFrom": false,
                "value": "Text on button"
              }]
            }]
          }, {
            "id": "6e78ba8d-ab1f-4b17-b1ed-a80c901930ae",
            "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2", "9178838a-5b5d-4021-b6b4-1706c826d0bc"],
            "items": [{
              "id": "b83ff6df-9c52-472c-b4e6-2f0c08e3de9d",
              "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2", "9178838a-5b5d-4021-b6b4-1706c826d0bc", "6e78ba8d-ab1f-4b17-b1ed-a80c901930ae"],
              "nodeFieldType": "USER_CHOICE",
              "name": "layoutContainer2",
              "isConnectableFrom": true,
              "items": [{
                "id": "b6d45c76-94b0-4c6d-bc72-049cd7f273be",
                "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2", "9178838a-5b5d-4021-b6b4-1706c826d0bc", "6e78ba8d-ab1f-4b17-b1ed-a80c901930ae", "b83ff6df-9c52-472c-b4e6-2f0c08e3de9d"],
                "nodeFieldType": "TEXT",
                "name": "text2",
                "isConnectableFrom": false,
                "value": "Text on button"
              }]
            }]
          }]
        }, {
          "id": "1ba0d63e-8eb8-45bc-8c81-edc44b5fb0c7",
          "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2"],
          "nodeFieldType": "CONTAINER",
          "name": "cloneablePanelContainer3",
          "isConnectableFrom": false,
          "items": []
        }, {
          "id": "b6a110e0-d0c1-4d8b-8050-43fc322ed55c",
          "parentIdsPath": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2"],
          "nodeFieldType": "CONTAINER",
          "name": "cloneablePanelContainerTimeout",
          "isConnectableFrom": false,
          "items": []
        }]
      }, {
        "icon": "iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFMSURBVHgB7ZY/TgJREId/S0ysTLC1Ag+glTZaeAQrK40xXgBOIJ4ALLQz0egBvICJjZWFCZU27Fa0LFBBwfKGFxJCNfMmgRcyX7P7kjfZb+f9mUnwVFxjghYSlBEXmXNqJHgsUjeoIE7yEuKVI8olRI4JajFBLSaoZUsy+e4IqB24y2kbQeQj4OUPqH/zY9iCzVMvp4F+rHYI9MdA44cXQ6Wu4Ezs3foPVN9ckRwiiMoOkF75TO4+82LYe3C+rKFyi7GSLWKnWMtmC6aXftNzxyFs1kW9TPVdNg7BDokWE1yESh1BpY5L8CE523PdzbF/Snn9588VC1IWmifA+T7EUOYe2vxOhhAL/l74Yj//WKstWzIpYkGS++j4plPT2XBhC2YDUPeIm0/gq4uVwW5Y14Xdg1pMUIsJajFBLSSYI14yEqzTC2KjmCXufgpw+VCp9xpinwAAAABJRU5ErkJggg==",
        "coords": { "x": 985.5, "y": 416.5 },
        "defId": "contentMessage2",
        "caption": "Sticker",
        "isConnectableTo": true,
        "id": "44aab6b3-c406-4016-a0e5-ee3a3a7d0138",
        "parentIdsPath": [],
        "nodeFieldType": "CONTENT_MESSAGE",
        "name": "stickerForm1",
        "isConnectableFrom": true,
        "items": [{
          "id": "fefe2d30-396b-4ead-84f9-e02ab3a595ab",
          "parentIdsPath": ["44aab6b3-c406-4016-a0e5-ee3a3a7d0138"],
          "nodeFieldType": "STICKER",
          "name": "dropdown1",
          "isConnectableFrom": false,
          "value": "abc123"
        }]
      }, {
        "icon": "iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFMSURBVHgB7ZY/TgJREId/S0ysTLC1Ag+glTZaeAQrK40xXgBOIJ4ALLQz0egBvICJjZWFCZU27Fa0LFBBwfKGFxJCNfMmgRcyX7P7kjfZb+f9mUnwVFxjghYSlBEXmXNqJHgsUjeoIE7yEuKVI8olRI4JajFBLSaoZUsy+e4IqB24y2kbQeQj4OUPqH/zY9iCzVMvp4F+rHYI9MdA44cXQ6Wu4Ezs3foPVN9ckRwiiMoOkF75TO4+82LYe3C+rKFyi7GSLWKnWMtmC6aXftNzxyFs1kW9TPVdNg7BDokWE1yESh1BpY5L8CE523PdzbF/Snn9588VC1IWmifA+T7EUOYe2vxOhhAL/l74Yj//WKstWzIpYkGS++j4plPT2XBhC2YDUPeIm0/gq4uVwW5Y14Xdg1pMUIsJajFBLSSYI14yEqzTC2KjmCXufgpw+VCp9xpinwAAAABJRU5ErkJggg==",
        "coords": { "x": 721.5, "y": 88.5 },
        "defId": "contentMessage2",
        "caption": "Sticker",
        "isConnectableTo": true,
        "id": "a762b410-77eb-40ca-ad65-20bdd4431874",
        "parentIdsPath": [],
        "nodeFieldType": "CONTENT_MESSAGE",
        "name": "stickerForm1",
        "isConnectableFrom": true,
        "items": [{
          "id": "ab544402-703f-4068-894b-2341069dc3ee",
          "parentIdsPath": ["a762b410-77eb-40ca-ad65-20bdd4431874"],
          "nodeFieldType": "STICKER",
          "name": "dropdown1",
          "isConnectableFrom": false,
          "value": "abc123"
        }]
      }, {
        "icon": "iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFMSURBVHgB7ZY/TgJREId/S0ysTLC1Ag+glTZaeAQrK40xXgBOIJ4ALLQz0egBvICJjZWFCZU27Fa0LFBBwfKGFxJCNfMmgRcyX7P7kjfZb+f9mUnwVFxjghYSlBEXmXNqJHgsUjeoIE7yEuKVI8olRI4JajFBLSaoZUsy+e4IqB24y2kbQeQj4OUPqH/zY9iCzVMvp4F+rHYI9MdA44cXQ6Wu4Ezs3foPVN9ckRwiiMoOkF75TO4+82LYe3C+rKFyi7GSLWKnWMtmC6aXftNzxyFs1kW9TPVdNg7BDokWE1yESh1BpY5L8CE523PdzbF/Snn9588VC1IWmifA+T7EUOYe2vxOhhAL/l74Yj//WKstWzIpYkGS++j4plPT2XBhC2YDUPeIm0/gq4uVwW5Y14Xdg1pMUIsJajFBLSSYI14yEqzTC2KjmCXufgpw+VCp9xpinwAAAABJRU5ErkJggg==",
        "coords": { "x": 623.5, "y": 966.5 },
        "defId": "contentMessage1",
        "caption": "Message",
        "isConnectableTo": true,
        "id": "60ba1e3c-0c8d-4437-b852-cf67c0a44a2a",
        "parentIdsPath": [],
        "nodeFieldType": "CONTENT_MESSAGE",
        "name": "messageForm1",
        "isConnectableFrom": false,
        "items": [{
          "id": "d9e14ffe-5762-4755-af24-918e557a2d02",
          "parentIdsPath": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a"],
          "nodeFieldType": "IMAGE",
          "name": "image1",
          "isConnectableFrom": false,
          "value": ""
        }, {
          "id": "2750bf16-5d94-47f0-9c38-7ac3528e868a",
          "parentIdsPath": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a"],
          "nodeFieldType": "RICH_TEXT",
          "name": "richText1",
          "isConnectableFrom": false,
          "value": ""
        }, {
          "id": "003b781c-9660-437c-9995-8170de91d37e",
          "parentIdsPath": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a"],
          "nodeFieldType": "CONTAINER",
          "name": "cloneablePanelContainer2",
          "isConnectableFrom": false,
          "items": [{
            "id": "65f0396e-690a-404b-97eb-1aaad718c1f3",
            "parentIdsPath": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a", "003b781c-9660-437c-9995-8170de91d37e"],
            "items": [{
              "id": "5811e1a3-6747-43b9-b5f4-ef6530651453",
              "parentIdsPath": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a", "003b781c-9660-437c-9995-8170de91d37e", "65f0396e-690a-404b-97eb-1aaad718c1f3"],
              "nodeFieldType": "USER_CHOICE",
              "name": "layoutContainer2",
              "isConnectableFrom": true,
              "items": [{
                "id": "4a321925-5c46-46fb-b1fa-9dedcf163792",
                "parentIdsPath": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a", "003b781c-9660-437c-9995-8170de91d37e", "65f0396e-690a-404b-97eb-1aaad718c1f3", "5811e1a3-6747-43b9-b5f4-ef6530651453"],
                "nodeFieldType": "TEXT",
                "name": "text2",
                "isConnectableFrom": false,
                "value": "Text on button"
              }]
            }]
          }]
        }, {
          "id": "57079cbd-d5a3-47c8-9eb1-32c691146870",
          "parentIdsPath": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a"],
          "nodeFieldType": "CONTAINER",
          "name": "cloneablePanelContainer3",
          "isConnectableFrom": false,
          "items": []
        }, {
          "id": "80297654-8ed4-4745-baa9-c5ea24ecaac3",
          "parentIdsPath": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a"],
          "nodeFieldType": "CONTAINER",
          "name": "cloneablePanelContainerTimeout",
          "isConnectableFrom": false,
          "items": []
        }]
      }, {
        "icon": "iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAF+SURBVHgB7Ze/S8NAFMe/FwqGDpJBxEXp6J+hYx2d7GL9AQ5uCuKktqNURBAcHBwcimM3N5266iQ4OBQXBx2CQ4mLp+8kJUKHl5x3nOU+EN4REvLh3d27F7G6f1SXEieAjOAUoicEGqVvuYZ7coSsUOICGsBdogCO4wV18YK6eEFdSnkenojGsb5YxczUJMrh2OD+W/yOneNzmIAtSHLNzfovMRuwBWsL80que/+A9vUN+skHbMBeg7OVaRU7t11rcgQ7g+UwVJHWG5fW9oaKhxdXud7LYnwX09rdXVtSsQhGBdPM6UgaFSQ5XUnjU6wrmatQD4M2Qp4PppLcwj5aR90wOJnITm065VyslpnseuRiVFBXjjAqqCtHWC0zRWBvkn6SqPOYLhpz+IsekZ3B55dXFWvVucLnahHEyl5Lch78aViXB11NFpMdNTuDJHFwdom7xyc3+0GCJE/bHdjE/3bq4gV18YK6/ANBgRiuIkQvgJRbNIBrCBFDfja/APtHoWK8YrmAAAAAAElFTkSuQmCC",
        "coords": { "x": 1061.5, "y": 842.5 },
        "defId": "externalFlow1",
        "caption": "External Flow",
        "isConnectableTo": true,
        "id": "2efa7ada-66a7-4c5b-8580-8442f62f8152",
        "parentIdsPath": [],
        "nodeFieldType": "EXTERNAL_FLOW",
        "name": "externalFlowForm1",
        "isConnectableFrom": false,
        "items": [{
          "id": "77054769-1660-488a-af4e-e5e8eb9702b7",
          "parentIdsPath": ["2efa7ada-66a7-4c5b-8580-8442f62f8152"],
          "nodeFieldType": "TEXT",
          "name": "dropdown2",
          "isConnectableFrom": false,
          "value": "3"
        }]
      }, {
        "icon": "iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAF+SURBVHgB7Ze/S8NAFMe/FwqGDpJBxEXp6J+hYx2d7GL9AQ5uCuKktqNURBAcHBwcimM3N5266iQ4OBQXBx2CQ4mLp+8kJUKHl5x3nOU+EN4REvLh3d27F7G6f1SXEieAjOAUoicEGqVvuYZ7coSsUOICGsBdogCO4wV18YK6eEFdSnkenojGsb5YxczUJMrh2OD+W/yOneNzmIAtSHLNzfovMRuwBWsL80que/+A9vUN+skHbMBeg7OVaRU7t11rcgQ7g+UwVJHWG5fW9oaKhxdXud7LYnwX09rdXVtSsQhGBdPM6UgaFSQ5XUnjU6wrmatQD4M2Qp4PppLcwj5aR90wOJnITm065VyslpnseuRiVFBXjjAqqCtHWC0zRWBvkn6SqPOYLhpz+IsekZ3B55dXFWvVucLnahHEyl5Lch78aViXB11NFpMdNTuDJHFwdom7xyc3+0GCJE/bHdjE/3bq4gV18YK6/ANBgRiuIkQvgJRbNIBrCBFDfja/APtHoWK8YrmAAAAAAElFTkSuQmCC",
        "coords": { "x": 373.5, "y": 568.5 },
        "defId": "externalFlow1",
        "caption": "External Flow",
        "isConnectableTo": true,
        "id": "36d9beca-30e9-46b9-b609-17e0f70c0ff3",
        "parentIdsPath": [],
        "nodeFieldType": "EXTERNAL_FLOW",
        "name": "externalFlowForm1",
        "isConnectableFrom": false,
        "items": [{
          "id": "7f84c3bc-46dc-426c-a3e6-e3313859bf1f",
          "parentIdsPath": ["36d9beca-30e9-46b9-b609-17e0f70c0ff3"],
          "nodeFieldType": "TEXT",
          "name": "dropdown2",
          "isConnectableFrom": false,
          "value": "3"
        }]
      }],
      "connections": [{
        "id": "reactflow__edge-startstart-b28b21a8-f1ba-4104-8cae-03333ec4b6e2b28b21a8-f1ba-4104-8cae-03333ec4b6e2",
        "target": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2"],
        "source": ["start"]
      }, {
        "id": "reactflow__edge-b28b21a8-f1ba-4104-8cae-03333ec4b6e2f790238b-bf90-4217-9556-9630917b8321-a762b410-77eb-40ca-ad65-20bdd4431874a762b410-77eb-40ca-ad65-20bdd4431874",
        "target": ["a762b410-77eb-40ca-ad65-20bdd4431874"],
        "source": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2", "9178838a-5b5d-4021-b6b4-1706c826d0bc", "cf6f4456-5c4e-4605-a0ec-d87d638a6981", "f790238b-bf90-4217-9556-9630917b8321"]
      }, {
        "id": "reactflow__edge-a762b410-77eb-40ca-ad65-20bdd4431874a762b410-77eb-40ca-ad65-20bdd4431874-44aab6b3-c406-4016-a0e5-ee3a3a7d013844aab6b3-c406-4016-a0e5-ee3a3a7d0138",
        "target": ["44aab6b3-c406-4016-a0e5-ee3a3a7d0138"],
        "source": ["a762b410-77eb-40ca-ad65-20bdd4431874"]
      }, {
        "id": "reactflow__edge-44aab6b3-c406-4016-a0e5-ee3a3a7d013844aab6b3-c406-4016-a0e5-ee3a3a7d0138-60ba1e3c-0c8d-4437-b852-cf67c0a44a2a60ba1e3c-0c8d-4437-b852-cf67c0a44a2a",
        "target": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a"],
        "source": ["44aab6b3-c406-4016-a0e5-ee3a3a7d0138"]
      }, {
        "id": "reactflow__edge-60ba1e3c-0c8d-4437-b852-cf67c0a44a2a5811e1a3-6747-43b9-b5f4-ef6530651453-2efa7ada-66a7-4c5b-8580-8442f62f81522efa7ada-66a7-4c5b-8580-8442f62f8152",
        "target": ["2efa7ada-66a7-4c5b-8580-8442f62f8152"],
        "source": ["60ba1e3c-0c8d-4437-b852-cf67c0a44a2a", "003b781c-9660-437c-9995-8170de91d37e", "65f0396e-690a-404b-97eb-1aaad718c1f3", "5811e1a3-6747-43b9-b5f4-ef6530651453"]
      }, {
        "id": "reactflow__edge-b28b21a8-f1ba-4104-8cae-03333ec4b6e2b83ff6df-9c52-472c-b4e6-2f0c08e3de9d-36d9beca-30e9-46b9-b609-17e0f70c0ff336d9beca-30e9-46b9-b609-17e0f70c0ff3",
        "target": ["36d9beca-30e9-46b9-b609-17e0f70c0ff3"],
        "source": ["b28b21a8-f1ba-4104-8cae-03333ec4b6e2", "9178838a-5b5d-4021-b6b4-1706c826d0bc", "6e78ba8d-ab1f-4b17-b1ed-a80c901930ae", "b83ff6df-9c52-472c-b4e6-2f0c08e3de9d"]
      }]
    };

    return (of({
      "type": "metadata", blockDefinitions: [
        {
          "defId": "contentMessage1",
          "icon": "iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFMSURBVHgB7ZY/TgJREId/S0ysTLC1Ag+glTZaeAQrK40xXgBOIJ4ALLQz0egBvICJjZWFCZU27Fa0LFBBwfKGFxJCNfMmgRcyX7P7kjfZb+f9mUnwVFxjghYSlBEXmXNqJHgsUjeoIE7yEuKVI8olRI4JajFBLSaoZUsy+e4IqB24y2kbQeQj4OUPqH/zY9iCzVMvp4F+rHYI9MdA44cXQ6Wu4Ezs3foPVN9ckRwiiMoOkF75TO4+82LYe3C+rKFyi7GSLWKnWMtmC6aXftNzxyFs1kW9TPVdNg7BDokWE1yESh1BpY5L8CE523PdzbF/Snn9588VC1IWmifA+T7EUOYe2vxOhhAL/l74Yj//WKstWzIpYkGS++j4plPT2XBhC2YDUPeIm0/gq4uVwW5Y14Xdg1pMUIsJajFBLSSYI14yEqzTC2KjmCXufgpw+VCp9xpinwAAAABJRU5ErkJggg==",
          "header": "MESSAGE",
          "text": "This block allows sending content and inline buttons",
          "formDefinition": {
            "formFieldType": "CONTAINER",
            "nodeFieldType": "CONTENT_MESSAGE",
            "name": "messageForm1",
            "caption": "Message",
            "width": 100,
            "isConnectableFrom": false,
            "isConnectableTo": true,
            "items": [
              {
                "formFieldType": "IMAGE",
                "nodeFieldType": "IMAGE",
                "name": "image1",
                "caption": "Image",
                "width": 100,
                "isConnectableFrom": false,
                "isRequired": true,
                "isDisabled": false,
                "maxCount": 10,
                "maxSize": 2 * 1024 * 1024, //2MB
                "url": "https://settings-service-dev.pin-up-chatbots.com/api/v1/upload/image/",
                "defaultValue": "",
                "value": []
              },
              {
                "formFieldType": "RICH_TEXT",
                "nodeFieldType": "RICH_TEXT",
                "name": "richText1",
                "caption": "Text Message",
                "width": 100,
                "isConnectableFrom": false,
                "isRequired": true,
                "isDisabled": false,
                "defaultValue": "",
                "options": [
                  {
                    "label": "first name",
                    "value": "{{first_name}}"
                  },
                  {
                    "label": "last name",
                    "value": "{{last_name}}"
                  },
                  {
                    "label": "username",
                    "value": "{{username}}"
                  },
                  {
                    "label": "phone number",
                    "value": "{{phone_number}}"
                  }
                ],
                "validator": ""
              },
              {
                "formFieldType": "CLONEABLE_PANEL_CONTAINER",
                "nodeFieldType": "CONTAINER",
                "name": "cloneablePanelContainer2",
                "caption": "Sub Button",
                "width": 100,
                "isConnectableFrom": false,
                "items": [
                  {
                    "formFieldType": "LAYOUT_CONTAINER",
                    "nodeFieldType": "USER_CHOICE",
                    "name": "layoutContainer2",
                    "caption": "",
                    "width": 100,
                    "isConnectableFrom": true,
                    "items": [
                      {
                        "formFieldType": "TEXT",
                        "nodeFieldType": "TEXT",
                        "name": "text2",
                        "caption": "Text on button",
                        "width": 100,
                        "isConnectableFrom": false,
                        "isRequired": true,
                        "isDisabled": false,
                        "defaultValue": "Text on button",
                        "validator": ""
                      }
                    ],
                    "isHorizontal": true
                  }
                ],
                "maxCount": 10,
                "minCount": 1,
                "defaultCount": 1
              },
              {
                "formFieldType": "CLONEABLE_PANEL_CONTAINER",
                "nodeFieldType": "CONTAINER",
                "name": "cloneablePanelContainer3",
                "caption": "External Link",
                "width": 100,
                "isConnectableFrom": false,
                "items": [
                  {
                    "formFieldType": "LAYOUT_CONTAINER",
                    "nodeFieldType": "EXTERNAL_LINK",
                    "name": "layoutContainer3",
                    "caption": "External Link",
                    "width": 100,
                    "isConnectableFrom": false,
                    "items": [
                      {
                        "formFieldType": "TEXT",
                        "nodeFieldType": "URL",
                        "name": "text3",
                        "caption": "URL",
                        "width": 100,
                        "isConnectableFrom": false,
                        "isRequired": true,
                        "isDisabled": false,
                        "defaultValue": "https://www.figma.com/",
                        "validator": "(https?:\\/\\/)?([\\w\\-])+\\.{1}([a-zA-Z]{2,63})([\\/\\w-]*)*\\/?\\??([^#\\n\\r]*)?#?([^\\n\\r]*)"
                      },
                      {
                        "formFieldType": "TEXT",
                        "nodeFieldType": "TEXT",
                        "name": "text4",
                        "caption": "URL Label",
                        "width": 100,
                        "isConnectableFrom": false,
                        "isRequired": true,
                        "isDisabled": false,
                        "defaultValue": "figma",
                        "validator": "^.{1,5}$"
                      }
                    ],
                    "isHorizontal": false
                  }
                ],
                "maxCount": 6,
                "minCount": 0,
                "defaultCount": 0
              },
              {
                "formFieldType": "CLONEABLE_PANEL_CONTAINER",
                "nodeFieldType": "CONTAINER",
                "name": "cloneablePanelContainerTimeout",
                "caption": "Timeout",
                "width": 100,
                "isConnectableFrom": false,
                "items": [
                  {
                    "formFieldType": "LAYOUT_CONTAINER",
                    "nodeFieldType": "TIMEOUT",
                    "name": "layoutContainerTimeout",
                    "caption": "Timeout",
                    "width": 100,
                    "isConnectableFrom": true,
                    "items": [
                      {
                        "formFieldType": "NUMBER",
                        "nodeFieldType": "TEXT",
                        "name": "numberTimeoutValue",
                        "caption": "Value",
                        "width": 100,
                        "isConnectableFrom": false,
                        "isRequired": true,
                        "isDisabled": false,
                        "defaultValue": "1",
                        "min": 1,
                        "max": 90
                      },
                      {
                        "formFieldType": "DROPDOWN",
                        "nodeFieldType": "TEXT",
                        "name": "dropdownTimeoutUnit",
                        "caption": "Select time unit",
                        "width": 100,
                        "isConnectableFrom": false,
                        "isRequired": true,
                        "isDisabled": false,
                        "defaultValue": "h",
                        "options": [
                          {
                            "label": "Hour",
                            "value": "h"
                          },
                          {
                            "label": "Minute",
                            "value": "m"
                          },
                          {
                            "label": "Day",
                            "value": "d"
                          }
                        ]
                      }
                    ],
                    "isHorizontal": false
                  }
                ],
                "maxCount": 1,
                "minCount": 0,
                "defaultCount": 0
              }
            ]
          }
        },
        {
          "defId": "contentMessage2",
          "icon": "iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFMSURBVHgB7ZY/TgJREId/S0ysTLC1Ag+glTZaeAQrK40xXgBOIJ4ALLQz0egBvICJjZWFCZU27Fa0LFBBwfKGFxJCNfMmgRcyX7P7kjfZb+f9mUnwVFxjghYSlBEXmXNqJHgsUjeoIE7yEuKVI8olRI4JajFBLSaoZUsy+e4IqB24y2kbQeQj4OUPqH/zY9iCzVMvp4F+rHYI9MdA44cXQ6Wu4Ezs3foPVN9ckRwiiMoOkF75TO4+82LYe3C+rKFyi7GSLWKnWMtmC6aXftNzxyFs1kW9TPVdNg7BDokWE1yESh1BpY5L8CE523PdzbF/Snn9588VC1IWmifA+T7EUOYe2vxOhhAL/l74Yj//WKstWzIpYkGS++j4plPT2XBhC2YDUPeIm0/gq4uVwW5Y14Xdg1pMUIsJajFBLSSYI14yEqzTC2KjmCXufgpw+VCp9xpinwAAAABJRU5ErkJggg==",
          "header": "STICKER",
          "text": "This block allows sending stickers",
          "formDefinition": {
            "formFieldType": "CONTAINER",
            "nodeFieldType": "CONTENT_MESSAGE",
            "name": "stickerForm1",
            "caption": "Sticker",
            "width": 100,
            "isConnectableFrom": true,
            "isConnectableTo": true,
            "items": [
              {
                "formFieldType": "DROPDOWN",
                "nodeFieldType": "STICKER",
                "name": "dropdown1",
                "caption": "Select Sticker",
                "width": 100,
                "isConnectableFrom": false,
                "isRequired": true,
                "isDisabled": false,
                "defaultValue": "abc123",
                "options": [
                  {
                    "label": "Happy cat",
                    "value": "abc123"
                  },
                  {
                    "label": "Prize",
                    "value": "cbd563"
                  }
                ]
              }
            ]
          }
        },
        {
          "defId": "menu1",
          "icon": "iVBORw0KGgoAAAANSUhEUgAAACkAAAAoCAYAAABjPNNTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEuSURBVHgB7dkxS8NAGAbg966pjYKigotxaAZRcbFubuLvcenq5tJZEP+Af8B/UCdxcxWyNCAFoQjBQknbNNckYznoR3uQS/me5ZY78vLd8S4Rlx/BVSLwpoAmbKJEBImn4Ob0UZx9Bu9K4RaWmmzXDySUZRNc4MbxvkQFcEhTOKQplQjpUDde7DTwcn4Mr0E+ovWfpHj9jfD880c+Q57kg3+0dsDcniNxf3JYrFTkr3pb9WK9+wrRH0+xqm7Lh+c62K3ViqlSbNab7E+mxQS6102YMJzNyHvJk+z0Btk1J1hXfsWdcEC+6hx5kt+jcfYeeygD96QO9yT35BLckzrck2XintThniwT96QO92SZOKQpHNKUioQUCGGx2HUj6aRoC1gYNPtFIpC2w5YfzQHLCqNkIwoyUwAAAABJRU5ErkJggg==",
          "header": "MENU",
          "text": "This block allows setting main bot menu",
          "formDefinition": {
            "formFieldType": "CONTAINER",
            "nodeFieldType": "MENU_EDITOR",
            "name": "menuForm1",
            "caption": "Menu",
            "width": 100,
            "isConnectableFrom": false,
            "isConnectableTo": true,
            "items": [
              {
                "formFieldType": "RICH_TEXT",
                "nodeFieldType": "RICH_TEXT",
                "name": "richText1",
                "caption": "Text Message",
                "width": 100,
                "isConnectableFrom": false,
                "isRequired": true,
                "isDisabled": false,
                "defaultValue": "",
                "options": [
                  {
                    "label": "first name",
                    "value": "{{first_name}}"
                  },
                  {
                    "label": "last name",
                    "value": "{{last_name}}"
                  },
                  {
                    "label": "username",
                    "value": "{{username}}"
                  },
                  {
                    "label": "phone number",
                    "value": "{{phone_number}}"
                  }
                ],
                "validator": ""
              },
              {
                "formFieldType": "CLONEABLE_PANEL_CONTAINER",
                "nodeFieldType": "CONTAINER",
                "name": "cloneablePanelContainer1",
                "caption": "Submenu button",
                "width": 100,
                "isConnectableFrom": false,
                "items": [
                  {
                    "formFieldType": "LAYOUT_CONTAINER",
                    "nodeFieldType": "USER_CHOICE",
                    "name": "layoutContainer1",
                    "caption": "Submenu button",
                    "width": 100,
                    "isConnectableFrom": true,
                    "items": [
                      {
                        "formFieldType": "TEXT",
                        "nodeFieldType": "TEXT",
                        "name": "text1",
                        "caption": "Text on button",
                        "width": 100,
                        "isConnectableFrom": false,
                        "isRequired": true,
                        "isDisabled": false,
                        "defaultValue": "Text on button",
                        "validator": ""
                      }
                    ],
                    "isHorizontal": true
                  }
                ],
                "maxCount": 6,
                "minCount": 1,
                "defaultCount": 1
              },
              {
                "formFieldType": "CLONEABLE_PANEL_CONTAINER",
                "nodeFieldType": "CONTAINER",
                "name": "cloneablePanelContainerTimeout",
                "caption": "Timeout",
                "width": 100,
                "isConnectableFrom": false,
                "items": [
                  {
                    "formFieldType": "LAYOUT_CONTAINER",
                    "nodeFieldType": "TIMEOUT",
                    "name": "layoutContainerTimeout",
                    "caption": "Timeout",
                    "width": 100,
                    "isConnectableFrom": true,
                    "items": [
                      {
                        "formFieldType": "NUMBER",
                        "nodeFieldType": "TEXT",
                        "name": "numberTimeoutValue",
                        "caption": "Value",
                        "width": 100,
                        "isConnectableFrom": false,
                        "isRequired": true,
                        "isDisabled": false,
                        "defaultValue": "3",
                        "min": 1,
                        "max": 90
                      },
                      {
                        "formFieldType": "DROPDOWN",
                        "nodeFieldType": "TEXT",
                        "name": "dropdownTimeoutUnit",
                        "caption": "Select time unit",
                        "width": 100,
                        "isConnectableFrom": false,
                        "isRequired": true,
                        "isDisabled": false,
                        "defaultValue": "h",
                        "options": [
                          {
                            "label": "Hour",
                            "value": "h"
                          },
                          {
                            "label": "Minute",
                            "value": "m"
                          },
                          {
                            "label": "Day",
                            "value": "d"
                          }
                        ]
                      }
                    ],
                    "isHorizontal": false
                  }
                ],
                "maxCount": 1,
                "minCount": 0,
                "defaultCount": 0
              }
            ]
          }
        },
        {
          "defId": "userEntry1",
          "icon": "iVBORw0KGgoAAAANSUhEUgAAACkAAAAoCAYAAABjPNNTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKnSURBVHgB7Zkxb9NAGIZfR7DQJQsMMOAFBhjaDiywJAMLLGVgJvkF9B+Q/ALaX9Ayg5QyMzRdGCgS6dAOgNRkgIEOuEM7NFXTe/vpa9zIdu5sR3IlP1J0rXW+vPfed993drxRBz5OsYYRaigaHlrea7S90Scj8AwNFJfFinHQR5HxUK3gGlCKzItSZF5cC5E3kJXbNcB/A9wx7S1frg0DIOgB/83n9ypw1EcWvNFHbKaqNn4DePxuLCyJ/jqw104n1kPd3cmbVWDhvYgk/7rA38/AQVdE0EX2qS5IH7rM9t4S8K1p+m7AFXcnn/8QARSza9z5tZLcf84HHrVELNluGGc/wF4h6m4bhw5SIB37sjhdIGFfCuOELsZYkTEcsBfJgR8sy99b9ej44jJzI0Wx1wJ+ro7DZSYideDdhA3APrXNeKco9LgvE4mbTGqRjCsOyjgcrCf3I3QrCt5PNwkzgyV2Iu8uSftnI3POu0hHhG7HTWYCO5G6fMEOMkM3ueQUqM5PwS5Pzt2XllUkDOMvKrZ4Pcx2c+wg4WqwCOTq5EkgreWgeWPn5PBQ2snl6dav/q/O8jorUBw62WEAG+yc1GWuziMznOhljPesbrETqfWW9TfrkmsMs+ZbYieSgc7lo0CtOlGcTFk+3q/5cWBfv+0rjtbeh2/jK8rXV1LT4+JRj3acdHi35yaSX6y192knPsfFxRkFhmu/A26noJ1lEUuBPLLpmTIJTupZR45rhDnTsWq5P+MwvaijT9aAF/siNhwCehqaNweOl/tSVpluJpO6JemecejoYU+WkK5SbBLcyd+bqet++gcxOsIPXaRrzKHqJl3jQ9jBloRHUmKfqUhFxc6Q8uVAXpQi86IUmRcV81J/gIJDkS3T9lE8AvP6p21+IumeA+642ePF7ozSAAAAAElFTkSuQmCC",
          "header": "ENTRY",
          "text": "This block will ask user for raw keyboard entry",
          "formDefinition": {
            "formFieldType": "CONTAINER",
            "nodeFieldType": "USER_ENTRY",
            "name": "userEntryForm1",
            "caption": "User Entry",
            "width": 100,
            "isConnectableFrom": false,
            "isConnectableTo": true,
            "items": [
              {
                "formFieldType": "TEXT",
                "nodeFieldType": "TEXT",
                "name": "text1",
                "caption": "Description",
                "width": 100,
                "isConnectableFrom": false,
                "isRequired": true,
                "isDisabled": false,
                "defaultValue": "Description",
                "validator": ""
              },
              {
                "formFieldType": "CLONEABLE_PANEL_CONTAINER",
                "nodeFieldType": "CONTAINER",
                "name": "cloneablePanelContainerTimeout",
                "caption": "Timeout",
                "width": 100,
                "isConnectableFrom": false,
                "items": [
                  {
                    "formFieldType": "LAYOUT_CONTAINER",
                    "nodeFieldType": "TIMEOUT",
                    "name": "layoutContainerTimeout",
                    "caption": "Timeout",
                    "width": 100,
                    "isConnectableFrom": true,
                    "items": [
                      {
                        "formFieldType": "NUMBER",
                        "nodeFieldType": "TEXT",
                        "name": "numberTimeoutValue",
                        "caption": "Value",
                        "width": 100,
                        "isConnectableFrom": false,
                        "isRequired": true,
                        "isDisabled": false,
                        "defaultValue": "3",
                        "min": 1,
                        "max": 90
                      },
                      {
                        "formFieldType": "DROPDOWN",
                        "nodeFieldType": "TEXT",
                        "name": "dropdownTimeoutUnit",
                        "caption": "Select time unit",
                        "width": 100,
                        "isConnectableFrom": false,
                        "isRequired": true,
                        "isDisabled": false,
                        "defaultValue": "h",
                        "options": [
                          {
                            "label": "Hour",
                            "value": "h"
                          },
                          {
                            "label": "Minute",
                            "value": "m"
                          },
                          {
                            "label": "Day",
                            "value": "d"
                          }
                        ]
                      }
                    ],
                    "isHorizontal": false
                  }
                ],
                "maxCount": 1,
                "minCount": 0,
                "defaultCount": 0
              }
            ]
          }
        },
        {
          "defId": "externalFlow1",
          "icon": "iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAF+SURBVHgB7Ze/S8NAFMe/FwqGDpJBxEXp6J+hYx2d7GL9AQ5uCuKktqNURBAcHBwcimM3N5266iQ4OBQXBx2CQ4mLp+8kJUKHl5x3nOU+EN4REvLh3d27F7G6f1SXEieAjOAUoicEGqVvuYZ7coSsUOICGsBdogCO4wV18YK6eEFdSnkenojGsb5YxczUJMrh2OD+W/yOneNzmIAtSHLNzfovMRuwBWsL80que/+A9vUN+skHbMBeg7OVaRU7t11rcgQ7g+UwVJHWG5fW9oaKhxdXud7LYnwX09rdXVtSsQhGBdPM6UgaFSQ5XUnjU6wrmatQD4M2Qp4PppLcwj5aR90wOJnITm065VyslpnseuRiVFBXjjAqqCtHWC0zRWBvkn6SqPOYLhpz+IsekZ3B55dXFWvVucLnahHEyl5Lch78aViXB11NFpMdNTuDJHFwdom7xyc3+0GCJE/bHdjE/3bq4gV18YK6/ANBgRiuIkQvgJRbNIBrCBFDfja/APtHoWK8YrmAAAAAAElFTkSuQmCC",
          "header": "EXTERNAL FLOW",
          "text": "This block will switch to external flow",
          "formDefinition": {
            "formFieldType": "CONTAINER",
            "nodeFieldType": "EXTERNAL_FLOW",
            "name": "externalFlowForm1",
            "caption": "External Flow",
            "width": 100,
            "isConnectableFrom": false,
            "isConnectableTo": true,
            "items": [
              {
                "formFieldType": "DROPDOWN",
                "nodeFieldType": "TEXT",
                "name": "dropdown2",
                "caption": "Select Flow",
                "width": 100,
                "isConnectableFrom": false,
                "isRequired": true,
                "isDisabled": false,
                "defaultValue": "3",
                "options": [
                  {
                    "label": "button 2 flow",
                    "value": "3"
                  },
                  {
                    "label": "button 1 flow",
                    "value": "2"
                  },
                  {
                    "label": "/start flow",
                    "value": "1"
                  }
                ]
              }
            ]
          }
        },
        {
          "defId": "note1",
          "icon": "iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMlSURBVHgB7Zu9bhNBFIWPEUkBhZ0CigQpoaEwBaGAhsYU0FDgPAHJE/AISd4gbxBoaTA1BUkBDUhJQwpAigtCQYrYBRQGKfHRapPdsVfZ+bk7I81+kou1R7tzztw7fztunL7BKSLmCiKnNgCRUxuAyKkNQOREb8BVSHF9qVy50QD4N0BpZlrJva+NP3/7wGAfNrgxgJW68xK40QFay8m1LhTyaQX40y9+xt11YGk1f3+WP9gE+q9gQsN6KjzfBR5um4lWoYjPa5Pfs8U7H5JWL+JgA/i6CV3sIoDiH72FKGXEk/bGOJWGwLct6GAeAazYk73Jlmc+MyxHGnk920rKf1nLp0CR+N87wPEucPtF/jc+uzcHHcwjoL0+mYsM3+MdOKFIPMOc4U6+j1v76d5FGdaHfZBGx2g+DN7s5K93H1crnrDFf77Ll9Hsi8wM4EOylWNIFvXeupQVf15+ETaYGcAwy/J/CCfoiuewuNDNf6c5L3AzExydwBoT8W3lew6jOpMqhDIVdiE+nRBp4t8AV+LZCRv0Q34N8Cye+DMgAPHEjwGBiCfVGxCQeFKtAYGJJ9UZEKB4Uo0BgYon8gYELJ7IGiAhPr3ns8OkvCWyBnDPwHXLL64me4+8L8urCzNNZA1QK+ci7NXdZsu9SDkDWNGsAVymBpDzKnIGNJXWn7ZO9yyeyBmw8Dx/faRsXQUgnsi9GVLzn29x+FKjeQ+41Z3sHD2IJzIGqPlPuIVehCfxRCYFmhpDk0fxRCYCOE5fBgWzX/ix5U08kTFgOKXHTwXzt6Oe9ualFDIGpG9qmQqBCVaRGwUMX1dXTX1EBpFjZoDPfJ5pwiVuDLBckmoxq6z+LM8ImRnAIS1rAg0oM/bbwhlm9jlqPQww7wMOX+evH2wnR2akoHDuBGVxcB5B5oiMZVjmSI/FTXvO+/vWs0i7U2Jc3bHlffBxBfjVgy12wyAnO6wIl7pVwZZ3JJ40nPxlhiHK/J8fb4LMLbs5M5iFok/2k5NhPBjlcBhuiP1nqOxR2csQXinKrQU8LnF1qKfCiJzaAERObQAipzYAkVMbgMg5A8lkggcNx5Z6AAAAAElFTkSuQmCC",
          "header": "NOTE",
          "text": "This block is storing admin notes. The content is not sent to users.",
          "formDefinition": {
            "formFieldType": "CONTAINER",
            "nodeFieldType": "NOTE",
            "name": "noteForm1",
            "caption": "Note",
            "width": 100,
            "isConnectableFrom": false,
            "isConnectableTo": false,
            "items": [
              {
                "formFieldType": "TEXT",
                "nodeFieldType": "TEXT",
                "name": "text1",
                "caption": "Description",
                "width": 100,
                "isConnectableFrom": false,
                "isRequired": true,
                "isDisabled": false,
                "defaultValue": "Description",
                "validator": ""
              }
            ]
          }
        }
      ]
    }) as unknown as Observable<BlocksDefinitionsRes>)
      .pipe(
        delay(1000),
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
      );
  }
}
